import React, { useState, useEffect } from "react";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import allApi from "../../../../api/allApi";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import { useLocalization } from "../../localization/LocalizationContext";
import { Modal, Button } from "react-bootstrap";

const WifiSchedule = ({
  isVisible,
  onClose,
  onScheduleSave,
  getList,
  refreshSchedules,
  schedulesList,
  networkId,
}) => {
  const [showScheduleForm, setShowScheduleForm] = useState(true);
  const [slotsBooked, setSlotsBooked] = useState(false);
  const [schedule, setSchedule] = useState({
    Monday: [],
    Tuesday: [],
    Wednesday: [],
    Thursday: [],
    Friday: [],
    Saturday: [],
    Sunday: [],
  });
  const [scheduleName, setScheduleName] = useState("");
  // const [schedulesList, setSchedulesList] = useState([]);
  const { localizationStrings } = useLocalization();
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");

  useEffect(() => {
    setShowScheduleForm(true);
  }, []);

  useEffect(() => {
    if (isVisible) {
      setShowScheduleForm(true);
      fetchSchedules();
    }
  }, [isVisible]);

  const closeSchedule = () => {
    setShowScheduleForm(false);
    setSlotsBooked(false);
    if (onClose) onClose();
  };

  const MAX_TIME_SLOTS = 3;
  const addTimeSlot = (day) => {
    const updatedSchedule = { ...schedule };

    // Check if the day has fewer than 3 time slots before adding a new one
    if (updatedSchedule[day].length < MAX_TIME_SLOTS) {
      updatedSchedule[day].push({ startTime: null, endTime: null });
      setSchedule(updatedSchedule);
    } else {
      console.log(`Maximum of ${MAX_TIME_SLOTS} time slots reached for ${day}`);
    }
  };
  // const addTimeSlot = (day) => {
  //   const updatedSchedule = { ...schedule };
  //   updatedSchedule[day].push({ startTime: null, endTime: null });
  //   setSchedule(updatedSchedule);
  // };

  const removeTimeSlot = (day, index) => {
    const updatedSchedule = { ...schedule };
    updatedSchedule[day].splice(index, 1);
    setSchedule(updatedSchedule);
  };

  const handleChange = (day, index, field, value) => {
    const updatedSchedule = { ...schedule };
    updatedSchedule[day][index][field] = value;
    setSchedule(updatedSchedule);
  };

  const saveSchedule = async () => {
    if (isSaveDisabled) return;
    await handleScheduleSlot();
    // setSlotsBooked(true);
    // setShowScheduleForm(false);
  };

  const fetchSchedules = async () => {
    if (refreshSchedules) {
      await refreshSchedules();
    }
  };

  const handleScheduleSlot = async () => {
    try {
      const api = new allApi();

      const scheduleSettings = {
        schDays: "1000000",
        schOnTime0: schedule.Monday[0]?.startTime?.format("HHmm") || "0000",
        schOffTime0: schedule.Monday[0]?.endTime?.format("HHmm") || "0000",
        schOnTime1: schedule.Tuesday[0]?.startTime?.format("HHmm") || "0000",
        schOffTime1: schedule.Tuesday[0]?.endTime?.format("HHmm") || "0000",
        schOnTime2: schedule.Wednesday[0]?.startTime?.format("HHmm") || "0000",
        schOffTime2: schedule.Wednesday[0]?.endTime?.format("HHmm") || "0000",
        schOnTime3: schedule.Thursday[0]?.startTime?.format("HHmm") || "0000",
        schOffTime3: schedule.Thursday[0]?.endTime?.format("HHmm") || "0000",
        schOnTime4: schedule.Friday[0]?.startTime?.format("HHmm") || "0000",
        schOffTime4: schedule.Friday[0]?.endTime?.format("HHmm") || "0000",
        schOnTime5: schedule.Saturday[0]?.startTime?.format("HHmm") || "0000",
        schOffTime5: schedule.Saturday[0]?.endTime?.format("HHmm") || "0000",
        schOnTime6: schedule.Sunday[0]?.startTime?.format("HHmm") || "0000",
        schOffTime6: schedule.Sunday[0]?.endTime?.format("HHmm") || "0000",
      };

      const payload = {
        networkId,
        scheduleName: scheduleName || "sample schedule",
        scheduleSettings: scheduleSettings,
        scheduleStatus: 0,
        createdAt: Math.floor(Date.now() / 1000),
      };

      const response = await api.postRequest(
        `api/wireless/configuration/ssidSchedule?networkId=${networkId}`,
        "",
        payload
      );

      if (response?.status === "OK") {
        setSuccessMessage(response?.message || "");

        if (refreshSchedules) {
          await refreshSchedules();
        }

        setShowScheduleForm(false);
        setShowSuccessModal(true);
        setSlotsBooked(true);
      }
    } catch (error) {
      console.error("Error scheduling the slots:", error);
    }
  };

  const hasAnyTimeSlot = Object.values(schedule).some(
    (slots) => slots.length > 0
  );
  const isSaveDisabled = !scheduleName.trim() || !hasAnyTimeSlot;

  const handleSuccessOk = async () => {
    setShowSuccessModal(false);

    if (refreshSchedules) {
      await refreshSchedules(); // reload list
    }

    setShowScheduleForm(false);
    setSlotsBooked(false);

    if (onClose) {
      onClose(); // close schedule form → goes back to list
    }
  };

  const handleDeleteSchedule = async (scheduleId) => {
    try {
      const api = new allApi();
      const response = await api.deleteRequest(
        `api/wireless/configuration/ssidSchedule?networkId=${networkId}&scheduleId=${scheduleId}`
      );
      if (response?.status === "OK") {
        setSuccessMessage(response?.message || "Delete Successfully");
        setShowSuccessModal(true);
        // Refresh the list after deletion
        if (refreshSchedules) {
          await refreshSchedules();
        }
      }
    } catch (error) {
      console.error("Error deleting schedule:", error);
    }
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <div>
        {showScheduleForm && !slotsBooked ? (
          <div className="schedule-height">
            <div className="schedule-week">
              <h4>{localizationStrings?.scheduleName}</h4>
              <div className="row d-flex">
                <div className="col-12 col-md-6 col-lg-6">
                  <input
                    type="text"
                    className="form-control"
                    placeholder={localizationStrings?.scheduleName}
                    value={scheduleName}
                    onChange={(e) => setScheduleName(e.target.value)}
                  />
                </div>
              </div>
              {/* <div className="border-line"></div> */}
              <p>
                {localizationStrings?.locationTimezone} - Asia/Kolkata (IST)
              </p>
              <h4>{localizationStrings?.days}</h4>
              <p>{localizationStrings?.slotInfo}</p>
              <div className="schedule-slot-scroller">
                {Object.keys(schedule).map((day) => (
                  <div className="schedule-days" key={day}>
                    <div className="sc-day-title">
                      <h4>{day}</h4>
                      <div>
                        <button
                          className="icon-btn"
                          onClick={() => addTimeSlot(day)}
                        >
                          <i className="fa fa-plus" aria-hidden="true"></i>
                        </button>
                      </div>
                    </div>
                    <div className="schedule-time">
                      {schedule[day].map((slot, index) => (
                        <div className="schedule-time-box" key={index}>
                          <div className="start-time">
                            <h4>{localizationStrings?.startOn}</h4>
                            <TimePicker
                              value={
                                slot.startTime
                                  ? dayjs.isDayjs(slot.startTime)
                                    ? slot.startTime
                                    : dayjs(slot.startTime, "HHmm")
                                  : null
                              }
                              onChange={(value) =>
                                handleChange(day, index, "startTime", value)
                              }
                              slotProps={{
                                textField: { className: "time-picker-input" },
                              }}
                              slots={{
                                openPickerIcon: () => (
                                  <AccessTimeIcon fontSize="small" />
                                ),
                              }}
                            />
                          </div>
                          <div className="end-time">
                            <h4>{localizationStrings?.endOn}</h4>

                            <TimePicker
                              value={
                                slot.endTime
                                  ? dayjs.isDayjs(slot.endTime)
                                    ? slot.endTime
                                    : dayjs(slot.endTime, "HHmm")
                                  : null
                              }
                              onChange={(value) =>
                                handleChange(day, index, "endTime", value)
                              }
                              slotProps={{
                                textField: {
                                  fullWidth: true,
                                  className: "time-picker-input",
                                },
                                popper: { placement: "bottom-start" },
                              }}
                              slots={{
                                openPickerIcon: () => (
                                  <AccessTimeIcon fontSize="small" />
                                ),
                              }}
                            />
                          </div>

                          <button
                            onClick={() => removeTimeSlot(day, index)}
                            className="delete-slot"
                          >
                            <i className="fa fa-trash" aria-hidden="true"></i>
                          </button>
                        </div>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="wifi-footer">
              <button
                type="button"
                className="btn btn-outline"
                onClick={closeSchedule}
              >
                {localizationStrings?.cancel}
              </button>
              <button
                type="button"
                className="text-btn primary-btn"
                onClick={saveSchedule}
                disabled={isSaveDisabled}
              >
                {localizationStrings?.save}
              </button>
            </div>
          </div>
        ) : (
          <div className="schedule-wrapper">
            {schedulesList.length > 0 ? (
              schedulesList.map((scheduleItem) => (
                <div className="schedule-item" key={scheduleItem.scheduleId}>
                  <div className="schedule-detail">
                    <h5>{scheduleItem.scheduleName}</h5>
                    <p>
                      {localizationStrings?.status}:{" "}
                      {scheduleItem.scheduleStatus === 1
                        ? "Active"
                        : "Inactive"}
                    </p>
                    <p>
                      {localizationStrings?.createdAt}:{" "}
                      {new Date(scheduleItem.createdAt * 1000).toLocaleString()}
                    </p>
                    <button
                      className="icon-btn"
                      onClick={() =>
                        handleDeleteSchedule(scheduleItem.scheduleId)
                      }
                    >
                      <i className="fa fa-trash" aria-hidden="true"></i>
                    </button>
                  </div>
                </div>
              ))
            ) : (
              <p>{localizationStrings?.noData}</p>
            )}
          </div>
        )}
        <Modal
          show={showSuccessModal}
          onHide={handleSuccessOk}
          aria-labelledby="contained-modal-title-vcenter"
          centered
          className="inc-alert index-2000"
          backdrop="static"
          keyboard={false}
        >
          <span className="success-icon">
            <i className="icon done"></i>
          </span>

          <h3>{localizationStrings?.success || "Success"}</h3>

          <p>{successMessage}</p>

          <Button onClick={handleSuccessOk}>
            {localizationStrings?.ok || "OK"}
          </Button>
        </Modal>
      </div>
    </LocalizationProvider>
  );
};

export default WifiSchedule;
